import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchPartsAvailable = () => apiActionCreator({
  'endpoint': '/quality-assurance/orders/parts-available',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PARTS_AVAILABLE,
    ActionTypes.FETCHED_PARTS_AVAILABLE,
    [
      ActionTypes.FETCHED_PARTS_AVAILABLE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchPartsForQualityAssuranceOrder = (order) => apiActionCreator({
  'endpoint': `/quality-assurance/orders/${order}/parts/list`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PARTS_FOR_QUALITY_ASSURANCE_ORDER,
    ActionTypes.FETCHED_PARTS_FOR_QUALITY_ASSURANCE_ORDER,
    [
      ActionTypes.FETCHED_PARTS_FOR_QUALITY_ASSURANCE_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const managePartInQualityAssuranceOrder = (order, index, data = {}) => (dispatch) => {
  const actionType = data.action === 'add' ? 'agregado' : 'eliminado';

  return dispatch(
    apiActionCreator({
      'endpoint': `/quality-assurance/orders/${order}/parts/list`,
      'authenticated': true,
      'types': [
        ActionTypes.MANAGING_PART_IN_QUALITY_ASSURANCE_ORDER,
        [
          () => {
            dispatch(fetchPartsAvailable());
            return {
              'type': ActionTypes.MANAGED_PART_IN_QUALITY_ASSURANCE_ORDER,
              'payload': {index, 'action': data.action},
            };
          },
          MessageActions.addMessageBoxInfo(`La parte ${data.partCode} ha sido ${actionType} satisfactoriamente`),
        ],
        [
          ActionTypes.MANAGED_PART_IN_QUALITY_ASSURANCE_ORDER_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      data,
    }),
  );
};

export const addPartInfo = (index, partInfo) => ({
  'type': ActionTypes.ADD_PART_INFO,
  'payload': {index, partInfo},
});
